import { get } from 'lodash';

export const getCommunitiesContext = state => state.communitiesContext;

export const getApplicationConfigFromContext = (communitiesContext, appDefinitionId) =>
  get(communitiesContext, appDefinitionId, {});

export const getApplicationConfig = (state, appDefinitionId) =>
  getApplicationConfigFromContext(getCommunitiesContext(state), appDefinitionId);
